import { render, staticRenderFns } from "./CreditTransferDialog.vue?vue&type=template&id=13486290&"
import script from "./CreditTransferDialog.vue?vue&type=script&lang=js&"
export * from "./CreditTransferDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports